var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramTravel48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./Travel48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 3.000000)",
    id: "pictogramTravel48",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle-7",
    strokeLinecap: "square",
    points: "7.5 4.5 7.5 0.8 16.5 0.8 16.5 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,6 L22,6 C23.1,6 24,6.9 24,8 L24,37 C24,38.1 23.1,39 22,39 L2,39 C0.9,39 0,38.1 0,37 L0,8 C0,6.9 0.9,6 2,6 Z",
    id: "Rectangle-5",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,33 L24,33 L24,37 C24,38.1 23.1,39 22,39 L2,39 C0.9,39 0,38.1 0,37 L0,33 Z",
    id: "Focus",
    fill: "#FFCC00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8,40.5 L6.8,41.3",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,12.8 L7.5,27",
    id: "Line-Copy-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3,40.5 L17.3,41.3",
    id: "Line-Copy",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,12.8 L16.5,27",
    id: "Line-Copy-3",
    strokeLinecap: "square"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramTravel48);
export default __webpack_public_path__ + "static/media/pictogramTravel48.6941c7df90ca941bafbca9f97d0dc6b3.svg";
export { ForwardRef as ReactComponent };